import { escapeRegExp } from 'es-toolkit';

export const UNIT_NAME_PREFIX = 'Unit';

const UNIT_LABEL_SEARCH_PATTERN = new RegExp(`^${escapeRegExp(UNIT_NAME_PREFIX)}(?:\\s+(\\S*\\d\\S*|\\S{1,3}))?$`, 'i');

export const stripUnitPrefix = (searchText: string) => {
  const trimmed = searchText.trim();
  const match = trimmed.match(UNIT_LABEL_SEARCH_PATTERN);
  return match ? (match[1] ?? '') : trimmed;
};
